import { render, staticRenderFns } from "./RegistAccountDetail.vue?vue&type=template&id=5957bb6d&scoped=true"
import script from "./RegistAccountDetail.vue?vue&type=script&lang=js"
export * from "./RegistAccountDetail.vue?vue&type=script&lang=js"
import style0 from "./RegistAccountDetail.vue?vue&type=style&index=0&id=5957bb6d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5957bb6d",
  null
  
)

export default component.exports